var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChatBotBro(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 300,
    height: 300,
    viewBox: "0 0 300 300",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12714_12641)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M263.041 82.9331C263.041 82.9331 252.151 39.2584 186.226 11.7148C120.301 -15.8288 61.3212 9.68145 47.8754 41.9566C34.4296 74.2317 48.5209 91.6603 39.5484 119.223C30.5759 146.786 -15.5194 181.695 3.08396 224.027C21.6873 266.359 108.74 278.449 179.184 269.716C249.627 260.982 304.663 164.228 263.041 82.9331Z",
    fill: "#657B8D"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M263.041 82.9331C263.041 82.9331 252.151 39.2584 186.226 11.7148C120.301 -15.8288 61.3212 9.68145 47.8754 41.9566C34.4296 74.2317 48.5209 91.6603 39.5484 119.223C30.5759 146.786 -15.5194 181.695 3.08396 224.027C21.6873 266.359 108.74 278.449 179.184 269.716C249.627 260.982 304.663 164.228 263.041 82.9331Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.601 267.906H283.201",
    stroke: "#263238",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.0005 267.906H266.4",
    stroke: "#263238",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5908 267.906H25.2008",
    stroke: "#263238",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.5 151.352H145.298V266.085H158.5V151.352Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.863954,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.8228 192.9V200.97H106.438V192.9H53.8228Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.863954,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.2314 165.046H51.1621V197.332H59.2314V165.046Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.863954,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.5909 197.47C62.5909 198.441 62.3995 199.402 62.0278 200.299C61.656 201.196 61.1111 202.011 60.4243 202.697C59.7374 203.383 58.9221 203.927 58.0249 204.297C57.1277 204.668 56.1662 204.858 55.1954 204.857C54.9535 204.857 54.7116 204.857 54.4784 204.857C53.1327 204.724 51.8493 204.225 50.7677 203.413C49.6861 202.602 48.8477 201.509 48.3436 200.254C47.8395 199 47.6891 197.631 47.9087 196.297C48.1283 194.962 48.7095 193.714 49.5891 192.687C50.4687 191.66 51.613 190.894 52.8977 190.472C54.1823 190.049 55.558 189.988 56.8753 190.293C58.1926 190.598 59.401 191.259 60.3691 192.203C61.3372 193.147 62.028 194.338 62.3663 195.647C62.5138 196.244 62.5892 196.856 62.5909 197.47Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.863954,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.1367 170.023C63.1321 171.982 62.3512 173.859 60.965 175.244C59.5788 176.628 57.7004 177.407 55.7412 177.409C55.4993 177.409 55.2574 177.409 55.0155 177.409C53.6692 177.28 52.3841 176.785 51.2999 175.976C50.2157 175.168 49.3741 174.077 48.8664 172.824C48.3588 171.57 48.2046 170.201 48.4207 168.866C48.6368 167.531 49.2148 166.281 50.092 165.251C50.9691 164.222 52.1118 163.453 53.3956 163.027C54.6795 162.602 56.0554 162.537 57.3737 162.839C58.6919 163.142 59.9021 163.799 60.8725 164.742C61.8429 165.684 62.5363 166.874 62.8775 168.182C63.0434 168.782 63.1305 169.401 63.1367 170.023Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.863954,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.3783 149.978L65.6221 155.77L67.8502 159.908L78.6064 154.117L76.3783 149.978Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.863954,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.3893 154.566L75.0932 157.417L71.7065 151.136L77.0112 148.277C77.4274 148.048 77.8851 147.906 78.3573 147.857C78.8294 147.808 79.3066 147.855 79.7606 147.993C80.2146 148.132 80.6364 148.36 81.001 148.663C81.3657 148.967 81.6659 149.341 81.8839 149.763C82.3174 150.599 82.4036 151.572 82.1238 152.472C81.844 153.371 81.2207 154.124 80.3893 154.566Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.863954,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.1744 127.93L56.7943 149.84L52.103 149.762L52.4745 127.853L57.1744 127.93Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.863954,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.4456 126.609L58.3506 132.656L51.2144 132.484L51.3094 126.436C51.3173 125.967 51.4174 125.505 51.604 125.075C51.7906 124.645 52.0601 124.256 52.3971 123.93C52.734 123.605 53.1319 123.349 53.5679 123.177C54.0038 123.005 54.4694 122.92 54.938 122.928C55.4114 122.935 55.8787 123.036 56.3126 123.225C56.7465 123.415 57.1383 123.689 57.4649 124.032C57.7916 124.374 58.0466 124.779 58.215 125.221C58.3834 125.664 58.4618 126.136 58.4456 126.609Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.863954,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.7293 135.879L64.4224 155.214L60.2754 153.011L70.5737 133.676L74.7293 135.879Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.863954,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.4593 135.283L73.6342 140.597L67.3359 137.253L70.1524 131.931C70.598 131.098 71.3551 130.475 72.2583 130.198C73.1615 129.922 74.1375 130.013 74.9733 130.454C75.81 130.898 76.4364 131.656 76.715 132.561C76.9936 133.467 76.9016 134.446 76.4593 135.283Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.863954,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.5174 135.793L50.7294 155.18L46.5738 157.375L36.3618 137.987L40.5174 135.793Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.863954,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.098 149.849C49.9466 148.953 49.5325 148.121 48.9082 147.46C48.284 146.798 47.4776 146.337 46.5911 146.134C45.7046 145.932 44.7778 145.996 43.9281 146.32C43.0784 146.644 42.3439 147.213 41.8176 147.955C41.2913 148.697 40.9969 149.578 40.9715 150.487C40.9462 151.396 41.1911 152.292 41.6752 153.062C42.1594 153.832 42.861 154.44 43.6913 154.811C44.5217 155.182 45.4434 155.299 46.3398 155.145C47.5399 154.94 48.6097 154.268 49.3143 153.275C50.0189 152.282 50.3008 151.05 50.098 149.849Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.863954,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.5904 150.454C57.1288 150.454 59.1866 148.396 59.1866 145.858C59.1866 143.32 57.1288 141.262 54.5904 141.262C52.0519 141.262 49.9941 143.32 49.9941 145.858C49.9941 148.396 52.0519 150.454 54.5904 150.454Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.863954,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.5897 148.51C69.728 147.611 69.5966 146.692 69.2122 145.868C68.8277 145.044 68.2075 144.352 67.4299 143.881C66.6523 143.409 65.7524 143.179 64.844 143.219C63.9355 143.259 63.0594 143.568 62.3265 144.106C61.5936 144.645 61.0367 145.388 60.7265 146.243C60.4162 147.098 60.3665 148.025 60.5836 148.908C60.8006 149.791 61.2747 150.59 61.9459 151.204C62.6171 151.817 63.4552 152.218 64.3541 152.355C64.9504 152.447 65.559 152.42 66.1451 152.277C66.7311 152.133 67.2831 151.876 67.7695 151.519C68.2558 151.162 68.6669 150.712 68.9792 150.196C69.2916 149.68 69.499 149.107 69.5897 148.51Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.863954,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.9928 134.022L43.8093 139.344L37.5024 142.687L34.6859 137.357C34.4659 136.943 34.3299 136.49 34.2855 136.023C34.2411 135.556 34.2894 135.086 34.4275 134.638C34.5655 134.19 34.7907 133.773 35.0901 133.413C35.3894 133.052 35.7571 132.754 36.1719 132.536C37.0088 132.096 37.9856 132.006 38.889 132.284C39.7923 132.563 40.5487 133.187 40.9928 134.022Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.863954,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.7081 158.722C68.7081 162.159 67.3427 165.456 64.9124 167.886C62.482 170.316 59.1858 171.682 55.7488 171.682C55.3168 171.682 54.8848 171.682 54.4788 171.63C52.1214 171.396 49.8731 170.521 47.9784 169.099C46.0837 167.677 44.615 165.763 43.7319 163.565C42.8488 161.366 42.5852 158.968 42.9697 156.631C43.3541 154.293 44.3719 152.106 45.9125 150.306C47.4531 148.506 49.4575 147.164 51.7078 146.423C53.9582 145.683 56.3683 145.574 58.6764 146.107C60.9845 146.641 63.1021 147.797 64.7991 149.45C66.4962 151.103 67.7077 153.189 68.302 155.483C68.57 156.542 68.7063 157.63 68.7081 158.722Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.863954,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.709 158.722C68.709 162.159 67.3436 165.455 64.9133 167.885C62.483 170.316 59.1867 171.681 55.7497 171.681C55.3177 171.681 54.8857 171.681 54.4797 171.629C53.9832 169.712 53.9328 167.706 54.3324 165.766C54.732 163.826 55.571 162.004 56.7849 160.438C57.9988 158.873 59.5553 157.607 61.3348 156.738C63.1143 155.868 65.0695 155.418 67.0502 155.421C67.4735 155.421 67.9142 155.421 68.3202 155.482C68.5823 156.542 68.7129 157.63 68.709 158.722Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.863954,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.963 197.704C136.164 188.3 130.324 178.894 120.921 176.693C111.518 174.493 102.111 180.332 99.9104 189.736C97.71 199.139 103.549 208.546 112.953 210.746C122.356 212.947 131.763 207.107 133.963 197.704Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.863954,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.186 201.539C124.506 199.737 126.547 194.775 124.745 190.454C122.944 186.134 117.981 184.093 113.661 185.895C109.341 187.697 107.299 192.659 109.101 196.98C110.903 201.3 115.866 203.341 120.186 201.539Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.863954,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.927 267.701H191.51L192.625 262.449C193.072 260.35 192.67 258.16 191.508 256.357C190.346 254.554 188.517 253.284 186.422 252.824C175.424 250.353 151.613 249.463 151.613 249.463C145.876 249.645 129.91 250.327 118.912 252.833C116.831 253.308 115.021 254.583 113.873 256.383C112.725 258.182 112.332 260.361 112.778 262.449L113.927 267.701Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.863954,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.389 250.742C161.453 249.826 151.639 249.463 151.639 249.463C148.027 249.576 140.355 249.895 132.424 250.742C134.74 258.647 142.584 264.47 151.906 264.47C161.229 264.47 169.073 258.621 171.389 250.742Z",
    fill: "#657B8D",
    stroke: "#263238",
    strokeWidth: 0.863954,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.94 230.656L237.766 224.188L195.597 192.722L190.771 199.19L232.94 230.656Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.863954,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.955 249.748L218.422 254.574L237.73 228.698L231.263 223.872L211.955 249.748Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.863954,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.645 221.747C229.226 220.968 229.956 220.31 230.792 219.812C231.628 219.315 232.554 218.987 233.517 218.847C234.48 218.708 235.461 218.759 236.403 218.999C237.346 219.238 238.233 219.662 239.012 220.244L239.574 220.702C240.573 221.613 241.303 222.781 241.685 224.079C242.066 225.376 242.085 226.753 241.738 228.061C241.392 229.368 240.694 230.555 239.719 231.493C238.745 232.431 237.532 233.084 236.213 233.381C234.894 233.678 233.518 233.607 232.236 233.177C230.954 232.746 229.814 231.973 228.941 230.94C228.069 229.907 227.495 228.654 227.285 227.318C227.074 225.983 227.234 224.614 227.746 223.363C227.978 222.79 228.28 222.247 228.645 221.747Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.863954,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.77 242.422C212.865 240.795 214.562 239.67 216.487 239.294C218.411 238.918 220.407 239.322 222.034 240.418C222.232 240.547 222.422 240.694 222.612 240.841C223.655 241.702 224.442 242.832 224.888 244.109C225.333 245.387 225.42 246.761 225.138 248.084C224.857 249.407 224.218 250.627 223.291 251.612C222.364 252.597 221.185 253.309 219.881 253.671C218.578 254.032 217.201 254.029 215.899 253.663C214.597 253.296 213.421 252.579 212.498 251.59C211.575 250.601 210.941 249.378 210.665 248.054C210.389 246.73 210.481 245.356 210.932 244.081C211.141 243.495 211.423 242.938 211.77 242.422Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.863954,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.563 251.677L201.721 252.872L202.181 248.194L190.023 247L189.563 251.677Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.863954,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.823 245.662L194.819 246.25L194.119 253.351L188.123 252.764C187.182 252.672 186.315 252.21 185.714 251.479C185.113 250.749 184.827 249.809 184.918 248.868C185.012 247.925 185.476 247.058 186.208 246.458C186.94 245.857 187.881 245.571 188.823 245.662Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.863954,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.833 248.686C201.783 247.271 203.002 246.057 204.422 245.114C205.841 244.171 207.432 243.517 209.105 243.189C210.777 242.862 212.498 242.867 214.168 243.206C215.838 243.544 217.425 244.209 218.838 245.161C219.192 245.403 219.529 245.654 219.858 245.921C221.684 247.431 223.062 249.412 223.841 251.65C224.62 253.888 224.771 256.296 224.277 258.614C223.783 260.931 222.662 263.069 221.038 264.794C219.414 266.52 217.348 267.766 215.064 268.399C212.781 269.032 210.368 269.027 208.087 268.385C205.806 267.742 203.745 266.486 202.129 264.754C200.512 263.021 199.401 260.879 198.917 258.56C198.432 256.24 198.593 253.832 199.382 251.598C199.74 250.569 200.227 249.591 200.833 248.686Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.863954,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.872 262.146L202.942 250.128L205.525 253.575L189.455 265.584L186.872 262.146Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.863954,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.204 261.965L189.619 258.621L193.542 263.805L189.127 267.114C188.433 267.633 187.563 267.855 186.706 267.732C185.849 267.609 185.076 267.15 184.556 266.457C184.059 265.771 183.848 264.918 183.969 264.079C184.09 263.241 184.533 262.482 185.204 261.965Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.863954,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.624 253.835C207.828 252.948 207.764 252.02 207.44 251.169C207.116 250.318 206.547 249.582 205.804 249.056C205.062 248.529 204.179 248.234 203.269 248.21C202.359 248.185 201.462 248.431 200.692 248.917C199.922 249.403 199.314 250.106 198.944 250.938C198.574 251.771 198.46 252.694 198.616 253.591C198.772 254.488 199.191 255.318 199.819 255.977C200.448 256.636 201.258 257.093 202.146 257.291C203.331 257.554 204.571 257.339 205.597 256.691C206.623 256.044 207.352 255.017 207.624 253.835Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.863954,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.141 274.224L218.526 257.74L222.059 258.241L219.683 274.725L216.141 274.224Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.863954,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.062 275.096L215.71 270.561L221.075 271.329L220.427 275.857C220.377 276.209 220.258 276.549 220.077 276.856C219.896 277.163 219.656 277.431 219.371 277.645C219.086 277.86 218.762 278.016 218.417 278.105C218.072 278.193 217.713 278.213 217.36 278.163C216.649 278.061 216.007 277.68 215.577 277.105C215.146 276.53 214.961 275.808 215.062 275.096Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.863954,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.443 257.161C223.037 256.527 222.451 256.028 221.761 255.727C221.071 255.426 220.307 255.336 219.565 255.468C218.824 255.601 218.139 255.95 217.596 256.472C217.053 256.995 216.677 257.666 216.515 258.401C216.354 259.137 216.414 259.904 216.688 260.605C216.962 261.307 217.438 261.911 218.055 262.342C218.673 262.774 219.404 263.012 220.157 263.028C220.91 263.044 221.651 262.836 222.286 262.431C223.137 261.885 223.738 261.023 223.955 260.035C224.172 259.047 223.988 258.014 223.443 257.161Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.863954,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.236 272.03L210.949 255.062L214.586 257.342L203.882 274.319L200.236 272.03Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.863954,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.621 272.445L201.55 267.779L207.088 271.235L204.151 275.909C203.688 276.64 202.956 277.159 202.112 277.352C201.269 277.544 200.383 277.395 199.65 276.937C198.919 276.477 198.4 275.745 198.208 274.903C198.015 274.061 198.164 273.177 198.621 272.445Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.863954,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.661 256.841C216.533 255.942 216.141 255.1 215.534 254.424C214.927 253.748 214.132 253.267 213.252 253.042C212.371 252.818 211.444 252.86 210.587 253.164C209.731 253.467 208.983 254.018 208.44 254.747C207.898 255.476 207.583 256.35 207.538 257.257C207.492 258.165 207.717 259.066 208.184 259.845C208.651 260.625 209.339 261.248 210.16 261.636C210.982 262.024 211.901 262.16 212.799 262.025C213.998 261.848 215.077 261.202 215.801 260.231C216.525 259.259 216.834 258.04 216.661 256.841Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.863954,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.814 208.726C204.935 203.499 207.28 192.678 202.053 184.558C196.826 176.437 186.005 174.092 177.885 179.319C169.764 184.547 167.419 195.367 172.646 203.488C177.873 211.608 188.694 213.954 196.814 208.726Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.863954,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.06 197.563C197.011 193.308 195.144 188.277 190.89 186.326C186.635 184.374 181.604 186.241 179.653 190.496C177.701 194.751 179.568 199.782 183.823 201.733C188.077 203.685 193.108 201.818 195.06 197.563Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.863954,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.897 159.37C167.409 159.37 179.984 146.795 179.984 131.282C179.984 115.77 167.409 103.195 151.897 103.195C136.385 103.195 123.81 115.77 123.81 131.282C123.81 146.795 136.385 159.37 151.897 159.37Z",
    fill: "#657B8D",
    stroke: "#263238",
    strokeWidth: 0.863954,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.055 149.987C198.087 142.425 201.862 133.313 202.946 123.701C204.029 114.088 202.378 104.365 198.181 95.6493C193.984 86.9337 187.413 79.5796 179.222 74.4328C171.032 69.2861 161.555 66.5557 151.881 66.5557C142.208 66.5557 132.731 69.2861 124.54 74.4328C116.35 79.5796 109.778 86.9337 105.581 95.6493C101.384 104.365 99.733 114.088 100.817 123.701C101.9 133.313 105.675 142.425 111.707 149.987H192.055Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.863954,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.33 98.5479H119.173C115.27 98.5479 112.106 101.712 112.106 105.615V128.354C112.106 132.257 115.27 135.421 119.173 135.421H183.33C187.233 135.421 190.397 132.257 190.397 128.354V105.615C190.397 101.712 187.233 98.5479 183.33 98.5479Z",
    fill: "#657B8D",
    stroke: "#263238",
    strokeWidth: 0.863954,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.57 115.49C121.419 113.115 122.965 111.051 125.007 109.569C127.049 108.087 129.49 107.257 132.012 107.187C134.534 107.117 137.018 107.81 139.139 109.176C141.259 110.542 142.918 112.517 143.897 114.842",
    stroke: "#263238",
    strokeWidth: 4.31977,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.267 115.49C160.115 113.115 161.662 111.051 163.703 109.569C165.745 108.087 168.187 107.257 170.708 107.187C173.23 107.117 175.714 107.81 177.835 109.176C179.956 110.542 181.614 112.517 182.593 114.842",
    stroke: "#263238",
    strokeWidth: 4.31977,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.125 124.035C145.342 125.748 146.177 127.323 147.472 128.465C148.768 129.607 150.435 130.237 152.162 130.237C153.889 130.237 155.557 129.607 156.852 128.465C158.148 127.323 158.982 125.748 159.199 124.035H145.125Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.863954,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.388 126.954C216.963 126.954 215.596 126.388 214.588 125.38C213.58 124.373 213.014 123.006 213.014 121.581V109.356C213.013 108.649 213.151 107.949 213.421 107.296C213.69 106.644 214.086 106.05 214.585 105.55C215.084 105.05 215.677 104.654 216.33 104.383C216.982 104.112 217.682 103.973 218.388 103.973C219.094 103.972 219.794 104.11 220.447 104.38C221.1 104.649 221.693 105.045 222.193 105.544C222.693 106.043 223.09 106.636 223.361 107.288C223.631 107.941 223.77 108.641 223.77 109.347V121.572C223.772 122.279 223.633 122.979 223.363 123.633C223.093 124.287 222.696 124.88 222.196 125.38C221.696 125.88 221.103 126.277 220.449 126.547C219.796 126.817 219.095 126.955 218.388 126.954Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.863954,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.9401 126.954C83.2336 126.955 82.5339 126.817 81.8809 126.548C81.228 126.278 80.6345 125.883 80.1346 125.383C79.6347 124.884 79.2381 124.292 78.9675 123.639C78.6969 122.986 78.5576 122.287 78.5576 121.581V109.356C78.5565 108.648 78.6949 107.948 78.965 107.294C79.2351 106.641 79.6315 106.047 80.1316 105.547C80.6316 105.047 81.2254 104.651 81.8789 104.381C82.5325 104.11 83.2329 103.972 83.9401 103.973C84.6457 103.973 85.3445 104.112 85.9965 104.382C86.6485 104.652 87.2409 105.048 87.7399 105.547C88.2389 106.046 88.6347 106.639 88.9048 107.29C89.1749 107.942 89.3138 108.641 89.3138 109.347V121.572C89.315 122.278 89.1768 122.978 88.9073 123.631C88.6377 124.284 88.2421 124.877 87.743 125.377C87.2438 125.877 86.6511 126.274 85.9985 126.544C85.346 126.815 84.6465 126.954 83.9401 126.954Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.863954,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.168 71.7905C96.4143 78.8139 93.88 87.1031 93.8931 95.5838V104.465",
    stroke: "#263238",
    strokeWidth: 12.0954,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.182 71.8256C199.292 66.03 194.036 61.2812 187.876 57.998C181.717 54.7148 174.844 52.9983 167.864 53H136.459C129.489 52.9952 122.624 54.7041 116.47 57.9764C110.316 61.2487 105.06 65.9839 101.167 71.7651",
    stroke: "#263238",
    strokeWidth: 6.04768,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.422 104.466V95.5844C210.435 87.1196 207.914 78.8446 203.182 71.8257",
    stroke: "#263238",
    strokeWidth: 12.0954,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.1772 94.9019H90.9719C86.8016 94.9019 83.4209 98.2825 83.4209 102.453V127.412C83.4209 131.583 86.8016 134.963 90.9719 134.963H98.1772C102.348 134.963 105.728 131.583 105.728 127.412V102.453C105.728 98.2825 102.348 94.9019 98.1772 94.9019Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.863954,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.7146 94.9019H93.4424V134.963H95.7146V94.9019Z",
    fill: "#657B8D",
    stroke: "#263238",
    strokeWidth: 0.863954,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.978 94.9019H204.772C200.602 94.9019 197.221 98.2825 197.221 102.453V127.412C197.221 131.583 200.602 134.963 204.772 134.963H211.978C216.148 134.963 219.528 131.583 219.528 127.412V102.453C219.528 98.2825 216.148 94.9019 211.978 94.9019Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.863954,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.515 94.9019H207.243V134.963H209.515V94.9019Z",
    fill: "#657B8D",
    stroke: "#263238",
    strokeWidth: 0.863954,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.08 91.2646C156.016 91.2655 159.889 90.2809 163.346 88.4005C166.804 86.5202 169.735 83.804 171.873 80.4997L176.746 72.9574C169.025 68.6933 160.336 66.4891 151.515 66.5572C142.695 66.6253 134.041 68.9633 126.386 73.3462L133.721 82.4523C135.928 85.2003 138.723 87.4185 141.9 88.9436C145.077 90.4687 148.556 91.2618 152.08 91.2646Z",
    fill: "#657B8D",
    stroke: "#263238",
    strokeWidth: 0.863954,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.297 139.153C153.297 138.983 153.247 138.816 153.152 138.674C153.057 138.531 152.922 138.421 152.764 138.355C152.606 138.29 152.432 138.273 152.265 138.306C152.097 138.339 151.943 138.422 151.822 138.543C151.702 138.663 151.619 138.817 151.586 138.985C151.553 139.153 151.57 139.326 151.635 139.484C151.7 139.642 151.811 139.777 151.953 139.872C152.095 139.967 152.262 140.017 152.433 140.017C152.662 140.017 152.882 139.926 153.044 139.764C153.206 139.602 153.297 139.383 153.297 139.153Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.297 142.056C153.297 141.885 153.247 141.718 153.152 141.576C153.057 141.434 152.922 141.324 152.764 141.258C152.606 141.193 152.432 141.176 152.265 141.209C152.097 141.242 151.943 141.325 151.822 141.445C151.702 141.566 151.619 141.72 151.586 141.888C151.553 142.055 151.57 142.229 151.635 142.387C151.7 142.545 151.811 142.68 151.953 142.775C152.095 142.87 152.262 142.92 152.433 142.92C152.662 142.92 152.882 142.829 153.044 142.667C153.206 142.505 153.297 142.285 153.297 142.056Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.006 141.607C150.164 141.506 150.284 141.355 150.349 141.179C150.413 141.002 150.419 140.81 150.364 140.63C150.309 140.45 150.198 140.293 150.046 140.183C149.894 140.072 149.71 140.014 149.522 140.018C149.365 140.12 149.244 140.27 149.18 140.446C149.115 140.623 149.11 140.815 149.164 140.995C149.219 141.175 149.331 141.332 149.483 141.442C149.635 141.553 149.818 141.611 150.006 141.607Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.198 141.607C155.332 141.605 155.463 141.571 155.582 141.51C155.7 141.448 155.803 141.36 155.882 141.252C155.96 141.143 156.013 141.019 156.035 140.887C156.057 140.755 156.048 140.62 156.01 140.492C155.971 140.364 155.903 140.247 155.811 140.15C155.719 140.053 155.606 139.978 155.48 139.932C155.355 139.886 155.22 139.87 155.087 139.885C154.954 139.9 154.827 139.945 154.714 140.017C154.581 140.02 154.449 140.053 154.331 140.115C154.212 140.177 154.11 140.265 154.031 140.373C153.952 140.481 153.9 140.606 153.878 140.738C153.856 140.87 153.864 141.005 153.903 141.133C153.942 141.261 154.01 141.378 154.102 141.475C154.194 141.572 154.307 141.647 154.433 141.693C154.558 141.739 154.693 141.755 154.825 141.74C154.958 141.725 155.086 141.68 155.198 141.607Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.422 171.569C175.424 169.089 151.614 168.199 151.614 168.199C145.877 168.381 129.911 169.063 118.913 171.577C116.831 172.05 115.019 173.325 113.871 175.125C112.722 176.925 112.33 179.106 112.779 181.193L122.965 228.849C123.465 231.159 124.74 233.23 126.579 234.716C128.417 236.203 130.709 237.016 133.073 237.022H172.34C174.704 237.016 176.995 236.203 178.834 234.716C180.672 233.23 181.948 231.159 182.448 228.849L192.625 181.193C193.072 179.095 192.671 176.905 191.509 175.102C190.346 173.298 188.518 172.028 186.422 171.569Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.863954,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.41 170.653C169.479 168.873 151.638 168.199 151.638 168.199C142.903 168.449 134.188 169.17 125.53 170.359L137.072 237.022H168.442L181.41 170.653Z",
    fill: "#657B8D",
    stroke: "#263238",
    strokeWidth: 0.863954,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.938 182.688H142.827C138.924 182.688 135.76 185.852 135.76 189.755V199.086C135.76 202.989 138.924 206.153 142.827 206.153H161.938C165.841 206.153 169.005 202.989 169.005 199.086V189.755C169.005 185.852 165.841 182.688 161.938 182.688Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.863954,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.801 192.355H141.418V197.738H146.801V192.355Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.863954,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.069 192.355H149.687V197.738H155.069V192.355Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.863954,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.346 192.355H157.964V197.738H163.346V192.355Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.863954,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.7998 227H134.304C135.099 227 135.863 227.316 136.425 227.879C136.988 228.441 137.304 229.204 137.304 230V267.362H64.7998V230C64.7998 229.204 65.1159 228.441 65.6785 227.879C66.2411 227.316 67.0042 227 67.7998 227Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.304 240.428C128.196 242.738 118.848 248.618 101.43 256.898C84.6298 264.89 70.8778 264.752 64.7998 264.134V267.362H137.304V240.428Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.304 265.124H64.7998V267.368H137.304V265.124Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.79 247.184C104.79 247.924 104.571 248.646 104.16 249.261C103.749 249.876 103.165 250.355 102.482 250.638C101.799 250.921 101.048 250.995 100.323 250.85C99.5976 250.706 98.9316 250.35 98.4088 249.827C97.886 249.305 97.53 248.639 97.3858 247.914C97.2416 247.188 97.3156 246.437 97.5985 245.754C97.8814 245.071 98.3605 244.487 98.9752 244.076C99.59 243.666 100.313 243.446 101.052 243.446C102.043 243.446 102.994 243.84 103.695 244.541C104.396 245.242 104.79 246.193 104.79 247.184Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12714_12641"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 300,
    height: 300,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatBotBro);
export default __webpack_public_path__ + "static/media/chatBotBro.c5b079bf714e4b91bdbeb82bdf715cc6.svg";
export { ForwardRef as ReactComponent };